"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PipeCommonUtil = void 0;
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const PointLocator_js_1 = __importDefault(require("jsts/org/locationtech/jts/algorithm/PointLocator.js"));
const Location_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Location.js"));
const pipeNode_1 = require("../pipeNode");
class PipeCommonUtil {
    static computeCoordArrV2(length, min, max, blankDis) {
        let closestValue = this.getFloorValueOfMultipleOf50(blankDis);
        let arr = new Array();
        if (length <= closestValue * 2) {
            //只考虑房间的大小原本是100或50的整数倍的情况
            if (Math.trunc(length / 2 % 50) == 25) { //加个trunc取整方法是因为有些数据质量太差，两边墙壁的距离不是整数
                arr.push(min + length / 2 - 25); //向某个方向偏25，凑个50。有超出blankDis的风险，但是暂时不管
            }
            else {
                arr.push(min + length / 2);
            }
        }
        else {
            let dis = length - closestValue * 4;
            if (dis <= 0) { //布设两个点
                let distanceToWall = length / 4;
                distanceToWall = this.getFloorValueOfMultipleOf50(distanceToWall);
                let lengthCenter = length - 2 * distanceToWall;
                if (lengthCenter < 1800) { //若两个点中间间隔小于1800，则需要强制调整至1800
                    let lengthTwoSide = length - 1800; //这里的1800是喷头间的最小间距(所有情况下都是固定的1800)
                    if (Math.trunc(lengthTwoSide / 2 % 50) == 25) {
                        arr.push(min + lengthTwoSide / 2 - 25);
                    }
                    else {
                        arr.push(min + lengthTwoSide / 2);
                    }
                    arr.push(arr[0] + 1800);
                }
                else {
                    arr.push(min + distanceToWall);
                    arr.push(max - distanceToWall);
                }
            }
            else { //多喷头的情况貌似暂时还没出现喷头间距小于1800的情况，暂时不处理
                let num = Math.ceil(length / (closestValue * 2));
                let distanceToWall = (length - (num - 1) * 2 * closestValue) / 2;
                distanceToWall = Math.round(distanceToWall);
                let leftDisToWall = distanceToWall;
                let rightDisToWall = distanceToWall;
                if (distanceToWall % 50 > 1) {
                    //缩小一边到50的倍数，加到另一边去，但有超过阈值的风险
                    let leftFloorValue = this.getFloorValueOfMultipleOf50(distanceToWall);
                    rightDisToWall += (leftDisToWall - leftFloorValue);
                    leftDisToWall = leftFloorValue;
                }
                arr.push(min + leftDisToWall);
                for (let i = 0; i < num - 2; i++) {
                    arr.push(arr[0] + closestValue * 2 * (i + 1));
                }
                arr.push(max - rightDisToWall);
                //调整两端，避免离墙太近
                //左边or下边
                if (leftDisToWall < closestValue) {
                    let adjustDis = closestValue - leftDisToWall;
                    if (arr[1] - arr[0] - adjustDis < 1800) { //两个喷头的间距不能小于1800
                        adjustDis = arr[1] - arr[0] - 1800;
                    }
                    arr[0] += adjustDis;
                }
                //右边or上边
                if (rightDisToWall < closestValue) {
                    let adjustDis = closestValue - rightDisToWall;
                    if (arr[arr.length - 1] - arr[arr.length - 2] - adjustDis < 1800) { //两个喷头的间距不能小于1800
                        adjustDis = arr[arr.length - 1] - arr[arr.length - 2] - 1800;
                    }
                    arr[arr.length - 1] -= this.getFloorValueOfMultipleOf50(adjustDis);
                }
            }
        }
        return arr;
    }
    static computePolygonCenter(points) {
        let centerX = 0;
        let centerY = 0;
        for (let point of points) {
            centerX += point.x;
            centerY += point.y;
        }
        centerX /= points.length;
        centerY /= points.length;
        return new Coordinate_js_1.default(centerX, centerY);
    }
    static findNearYArrIndices(currentIndex, yArr, blankDis) {
        let nearIndices = [];
        for (let i = 0; i < yArr.length; i++) {
            if (i == currentIndex)
                continue;
            if (Math.abs(yArr[currentIndex] - yArr[i]) < 2 * blankDis + 200) { //加200的容差
                nearIndices.push(i);
            }
        }
        return nearIndices;
    }
    static findValueInGroup(targetX, valueArrGroup) {
        if (!valueArrGroup) {
            return false;
        }
        for (let xArr of valueArrGroup) {
            for (let x of xArr) {
                if (Math.abs(targetX - x) < 800) { //加了800的容差，避免由于横向调整点导致的，误判为走廊的情况
                    return true;
                }
            }
        }
        return false;
    }
    static findValueInGroup_V2(currentX, currentY, valueArrGroup, nearY, polygonSegs) {
        if (!valueArrGroup) {
            return false;
        }
        for (let xArr of valueArrGroup) {
            for (let x of xArr) {
                if (Math.abs(currentX - x) < 800) { //加了800的容差，避免由于横向调整点导致的，误判为走廊的情况
                    //可选：判断两个点是否隔着墙
                    if (polygonSegs && polygonSegs.length > 0) {
                        let currentSeg = new LineSegment_js_1.default(currentX, currentY, x, nearY);
                        for (let seg of polygonSegs) {
                            if (currentSeg.intersection(seg)) {
                                return false;
                            }
                        }
                    }
                    return true;
                }
            }
        }
        return false;
    }
    static adJustChildPipePoints(polygonSegs_local, xArr, y, blankDis, minDisToWall, polygon_local) {
        //单列管点的情况大多不用处理，特殊情况另说
        if (xArr.length == 1) {
            return xArr;
        }
        //将超出多边形的点分组并移除
        let indicesGroups = new Array();
        indicesGroups.push(new Array());
        let pointLocator = new PointLocator_js_1.default();
        //1.要被移除的点判断一下能否向上面或下面的邻近点组靠近？
        //2.相邻两行点之间有一片空间怎么办，是个问题，补一行？好像可行
        //3.还有别的情况吗
        for (let i = 0; i < xArr.length; i++) {
            let inPolygon = pointLocator.locateInPolygon(new Coordinate_js_1.default(xArr[i], y), polygon_local) === Location_js_1.default.INTERIOR;
            if (inPolygon) {
                indicesGroups[indicesGroups.length - 1].push(i);
            }
            else {
                if (indicesGroups[indicesGroups.length - 1].length > 0)
                    indicesGroups.push(new Array());
            }
        }
        //移除最后的空数组
        if (indicesGroups[indicesGroups.length - 1].length == 0) {
            indicesGroups.pop();
        }
        //复制一份，避免方法里反复修改xArr，相互影响
        let copyXArr = xArr.concat();
        for (let indicesGroup of indicesGroups) {
            //如果等于首尾的点，就不用调整了
            //处理左边
            if (indicesGroup[0] != 0) {
                let firstIndex = indicesGroup[0];
                let seg = new LineSegment_js_1.default(copyXArr[firstIndex], y, copyXArr[firstIndex - 1], y);
                let intersectPoint = this.computeIntersectPoint_V2(seg, polygonSegs_local, true);
                let distanceToWall = copyXArr[firstIndex] - intersectPoint.x;
                //分三段情况处理
                if (distanceToWall < minDisToWall) { //不用插入新点，需要将原来的点向右调整，和墙的距离为最小距离
                    copyXArr[firstIndex] = intersectPoint.x + minDisToWall;
                }
                else if (distanceToWall < blankDis) { //不用插入新点，也不用调整原来的点
                }
                else { //插入新点，和墙的距离为最小距离就行(TODO：这里有可能会导致两个管点之间的距离不到1800)
                    let insertX = intersectPoint.x + minDisToWall;
                    //判断两个管点之间的距离是否不到1800，是的话则不补点
                    if (copyXArr[firstIndex] - insertX > 1800) {
                        copyXArr.splice(firstIndex, 0, insertX);
                        //插入点后需要调整所有的索引
                        this.updataIndicesGroups(firstIndex, indicesGroups);
                        //Group里也得加个新索引
                        indicesGroup.splice(0, 0, firstIndex);
                    }
                }
            }
            //处理右边
            if (indicesGroup[indicesGroup.length - 1] != copyXArr.length - 1) {
                let lastIndex = indicesGroup[indicesGroup.length - 1];
                let seg = new LineSegment_js_1.default(copyXArr[lastIndex], y, copyXArr[lastIndex + 1], y);
                let intersectPoint = this.computeIntersectPoint_V2(seg, polygonSegs_local, false);
                let distanceToWall = intersectPoint.x - copyXArr[lastIndex];
                //分三段情况处理
                if (distanceToWall < minDisToWall) { //不用插入新点，需要将原来的点向右调整，和墙的距离为最小距离
                    copyXArr[lastIndex] = intersectPoint.x - minDisToWall;
                }
                else if (distanceToWall < blankDis) { //不用插入新点，也不用调整原来的点
                }
                else { //插入新点，和墙的距离为最小距离就行
                    let insertX = intersectPoint.x - minDisToWall;
                    //判断两个管点之间的距离是否不到1800，是的话则不补点
                    if (insertX - copyXArr[lastIndex] > 1800) {
                        copyXArr.splice(lastIndex + 1, 0, insertX);
                        //插入点后需要调整所有的索引
                        this.updataIndicesGroups(lastIndex + 1, indicesGroups);
                        //Group里也得加个新索引
                        indicesGroup.splice(indicesGroup.length, 0, lastIndex + 1);
                    }
                }
            }
        }
        //只加入需要的点
        let newXArr = new Array();
        for (let indicesGroup of indicesGroups) {
            for (let index of indicesGroup) {
                newXArr.push(copyXArr[index]);
            }
        }
        return newXArr;
    }
    static isInPolygon(point, polygon, polygonSegs) {
        let pointLocator = new PointLocator_js_1.default();
        if (pointLocator.locateInPolygon(point, polygon) !== Location_js_1.default.INTERIOR) {
            return false;
        }
        //还要判断四个方向的100距离范围内有无其他要素
        const disBuffer = 99; //设置为99,避免过滤掉刚好满足100条件的喷头
        let segs = [
            new LineSegment_js_1.default(point.x, point.y, point.x - disBuffer, point.y),
            new LineSegment_js_1.default(point.x, point.y, point.x + disBuffer, point.y),
            new LineSegment_js_1.default(point.x, point.y, point.x, point.y - disBuffer),
            new LineSegment_js_1.default(point.x, point.y, point.x, point.y + disBuffer)
        ];
        for (let seg of segs) {
            for (let polygonSeg of polygonSegs) {
                if (seg.intersection(polygonSeg)) {
                    return false;
                }
            }
        }
        return true;
    }
    static adJustChildPipePoints_V2(polygonSegs_local, xArr, y, blankDis, minDisToWall, polygon_local) {
        //单列管点的情况大多不用处理，特殊情况另说
        if (xArr.length == 1) {
            return {
                adjustedXArr: xArr,
                removedXArr: []
            };
        }
        //将超出多边形的点分组并移除
        let indicesGroups = new Array();
        indicesGroups.push(new Array());
        //记录被移除的X坐标的数组
        let removedXArr = new Array();
        for (let i = 0; i < xArr.length; i++) {
            let inPolygon = this.isInPolygon(new Coordinate_js_1.default(xArr[i], y), polygon_local, polygonSegs_local);
            if (inPolygon) {
                indicesGroups[indicesGroups.length - 1].push(i);
            }
            else {
                if (indicesGroups[indicesGroups.length - 1].length > 0)
                    indicesGroups.push(new Array());
                removedXArr.push(xArr[i]);
                //看看两次移除的情况下，能否在中间补个点
                if (i > 0 && removedXArr.indexOf(xArr[i - 1]) > -1) {
                    let centerX = (xArr[i - 1] + xArr[i]) / 2;
                    if (this.isInPolygon(new Coordinate_js_1.default(centerX, y), polygon_local, polygonSegs_local)) {
                        //补充的点独自为一组
                        indicesGroups[indicesGroups.length - 1].push(i);
                        xArr.splice(i, 0, centerX);
                        i++;
                        indicesGroups.push(new Array());
                    }
                }
            }
        }
        //移除最后的空数组
        if (indicesGroups[indicesGroups.length - 1].length == 0) {
            indicesGroups.pop();
        }
        //复制一份，避免方法里反复修改xArr，相互影响
        let copyXArr = xArr.concat();
        for (let indicesGroup of indicesGroups) {
            //如果等于首尾的点，就不用调整了
            //处理左边
            if (indicesGroup[0] != 0) {
                let firstIndex = indicesGroup[0];
                let seg = new LineSegment_js_1.default(copyXArr[firstIndex], y, copyXArr[firstIndex - 1] - 100, y);
                let intersectPoint = this.computeIntersectPoint_V2(seg, polygonSegs_local, true);
                if (!intersectPoint) {
                    continue;
                }
                let distanceToWall = copyXArr[firstIndex] - intersectPoint.x;
                //分三段情况处理
                if (distanceToWall < minDisToWall) { //不用插入新点，需要将原来的点向右调整，和墙的距离为最小距离
                    copyXArr[firstIndex] = intersectPoint.x + minDisToWall;
                }
                else if (distanceToWall < blankDis) { //不用插入新点，也不用调整原来的点
                }
                else { //插入新点，和墙的距离为最小距离就行
                    let insertX = intersectPoint.x + minDisToWall;
                    //如果加了之后两个管点距离不到1800，则跳过。
                    //但可能会距离墙壁过远的问题，不好处理，暂时忽略。
                    if (Math.abs(insertX - copyXArr[firstIndex]) >= 1800 && this.isInPolygon(new Coordinate_js_1.default(insertX, y), polygon_local, polygonSegs_local)) {
                        copyXArr.splice(firstIndex, 0, insertX);
                        //插入点后需要调整所有的索引
                        this.updataIndicesGroups(firstIndex, indicesGroups);
                        //Group里也得加个新索引
                        indicesGroup.splice(0, 0, firstIndex);
                    }
                }
            }
            //处理右边
            if (indicesGroup[indicesGroup.length - 1] != copyXArr.length - 1) {
                let lastIndex = indicesGroup[indicesGroup.length - 1];
                let seg = new LineSegment_js_1.default(copyXArr[lastIndex], y, copyXArr[lastIndex + 1] + 100, y);
                let intersectPoint = this.computeIntersectPoint_V2(seg, polygonSegs_local, false);
                if (!intersectPoint) {
                    continue;
                }
                let distanceToWall = intersectPoint.x - copyXArr[lastIndex];
                //分三段情况处理
                if (distanceToWall < minDisToWall) { //不用插入新点，需要将原来的点向右调整，和墙的距离为最小距离
                    copyXArr[lastIndex] = intersectPoint.x - minDisToWall;
                }
                else if (distanceToWall < blankDis) { //不用插入新点，也不用调整原来的点
                }
                else { //插入新点，和墙的距离为最小距离就行
                    let insertX = intersectPoint.x - minDisToWall;
                    if (Math.abs(insertX - copyXArr[lastIndex]) >= 1800 && this.isInPolygon(new Coordinate_js_1.default(insertX, y), polygon_local, polygonSegs_local)) {
                        copyXArr.splice(lastIndex + 1, 0, insertX);
                        //插入点后需要调整所有的索引
                        this.updataIndicesGroups(lastIndex + 1, indicesGroups);
                        //Group里也得加个新索引
                        indicesGroup.splice(indicesGroup.length, 0, lastIndex + 1);
                    }
                }
            }
        }
        //只加入需要的点
        let newXArr = new Array();
        for (let indicesGroup of indicesGroups) {
            for (let index of indicesGroup) {
                newXArr.push(copyXArr[index]);
            }
        }
        return {
            adjustedXArr: newXArr,
            removedXArr: removedXArr
        };
    }
    static traverseToGetMainPipes(node, mainPipes) {
        for (let child of node._children) {
            if (child._type != pipeNode_1.PipeNodeType.Main)
                continue;
            mainPipes.push(new LineSegment_js_1.default(node._point, child._point));
            this.traverseToGetMainPipes(child, mainPipes);
        }
    }
    static traverseToGetChildPipes(node, childPipes) {
        for (let child of node._children) {
            if (child._type == pipeNode_1.PipeNodeType.Main)
                continue;
            childPipes.push(new LineSegment_js_1.default(node._point, child._point));
            this.traverseToGetMainPipes(child, childPipes);
        }
    }
    static traverseToGetMainPipeNodes(node, mainPipeNodes) {
        mainPipeNodes.push(node);
        for (let child of node._children) {
            if (child._type != pipeNode_1.PipeNodeType.Main)
                continue;
            this.traverseToGetMainPipeNodes(child, mainPipeNodes);
        }
    }
    static getFloorValueOfMultipleOf50(value) {
        return Math.floor(Math.round(value) / 50) * 50;
    }
    //只返回第一个节点的话会出现部分补充的点在柱子内的情况
    static computeIntersectPoint_V2(targetSeg, segs, getFirstIntersectP) {
        let intersectPoints = new Array();
        for (let seg of segs) {
            let intersectPoint = targetSeg.intersection(seg);
            if (intersectPoint) {
                intersectPoints.push(intersectPoint);
            }
        }
        if (intersectPoints.length == 0) {
            console.error("没有交点");
            return null;
        }
        if (getFirstIntersectP) { //返回第一个交点
            return intersectPoints[0];
        }
        else { //返回第二个交点
            return intersectPoints[intersectPoints.length - 1];
        }
    }
    static updataIndicesGroups(insertIndex, indicesGroups) {
        for (let indicesGroup of indicesGroups) {
            for (let i = 0; i < indicesGroup.length; i++) {
                if (indicesGroup[i] >= insertIndex) {
                    indicesGroup[i]++;
                }
            }
        }
    }
}
exports.PipeCommonUtil = PipeCommonUtil;
